import React, { useContext, useEffect, useState } from 'react';
import Select, { createFilter } from 'react-select';
import { Modal, Button, Accordion, Row, Col, FloatingLabel, Dropdown, ButtonGroup } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import { toast } from 'react-toastify';
import { StateContext } from '../../layouts/Dashboard/LayoutDashboard';
import CustomOption from '../../utils/Elements/CustomOption';
import '../Pages.css';

export const BAQForm = ({ showModal, closeModal, companyInfo }) => {

  const api = process.env.REACT_APP_API_ENDPOINT;
  const postingCompanyEndpoint = `${api}/v1/customers/PostingCompanies`;
  const shippingAddressEndpoint = `${api}/v1/customers/ShippingAddresses`;
  //const [identity, setIdentity] = useState({});
  const { allStates } = useContext(StateContext);

  const [validated, setValidated] = useState(false);
  const [activeKey, setActiveKey] = useState("1");
  const [addressOpen, setAddressOpen] = useState(false);
  const [listOpen, setListOpen] = useState(true);
  const [addresses, setAddresses] = useState([]);
  const [addressSelectPayload, setAddressSelectPayload] = useState([]);
  const [masterCompanies, setMasterCompanies] = useState([]);
  const [masterCompanyStates, setMasterCompanyStates] = useState([]);
  const [masterCompanyBranches, setMasterCompanyBranches] = useState([]);
  const [branchStates, setBranchStates] = useState([]); //filtered based on master company
  const [branchCompanies, setBranchCompanies] = useState([]); //filtered based on master company and master company state
  const [profile, setProfile] = useState({
    masterCompany: null, //list, visible if posting comp
    branchState: null, //list, visible if posting comp
    branchCompany: null, //list, visible if posting comp

    id: 0, //not displayed, 0 indicates new mode, not 0 indicatred edit mode
    name: "", //hidden if posting comp
    address1: "", //read only if posting comp
    address2: "",//read only if posting comp
    city: "",//read only if posting comp
    state: null, //list, read only if posting comp
    zip: "", //read only if posting comp
    isSelected: false, //not displayed
  });

  const getStoredToken = () => {
    return localStorage.getItem('token');
  };

  const storedToken = getStoredToken();

  const [addressSource, setAddressSource] = useState(0); //0=New, 2=OOH

  const showFailedMsg = (msg) => {
    console.warn(msg);
    toast.error(msg, {
      position: toast.POSITION.BOTTOM_RIGHT,
      autoClose: 5000,
      paueOnHover: true,
      theme: 'colored'
    });
  };
  const showSuccessMsg = (msg) => {
    console.log(msg);
    toast.success(msg, {
      position: toast.POSITION.BOTTOM_RIGHT,
      autoClose: 5000,
      paueOnHover: true,
      theme: 'colored'
    });
  };
  const handleProfileChange = (event) => {
    const { name, value } = event.target;
    setProfile((prevProfile) => ({
      ...prevProfile,
      [name]: value,
    }));
  };
  const handleStateChange = (value) => {
    setProfile((prevProfile) => ({
      ...prevProfile,
      "state": value,
    }));
  };
  const handleMasterCompanyChange = (value) => {
    //console.log("MasterCompanyChange");
    setProfile((prevProfile) => ({
      ...prevProfile,
      "masterCompany": value,
      "branchState": null,
      "branchCompany": null,
      "company": "",
      "address1": "",
      "address2": "",
      "city": "",
      "state": null,
      "zip": "",
    }));
    filterBranchStates(value ? value.value : null);
    filterBranchCompanies(value ? value.value : null, null);
  };
  const handleBranchStateChange = (value) => {
    //console.log("BranchStateChange");
    setProfile((prevProfile) => ({
      ...prevProfile,
      "branchState": value,
      "branchCompany": null,
      "name": "",
      "address1": "",
      "address2": "",
      "city": "",
      "state": null,
      "zip": "",
    }));
    filterBranchCompanies(profile && profile.masterCompany ? profile.masterCompany.value : null, value ? value.value : null);
  };
  const handleBranchCompanyChange = (value) => {

    //locate branch in masterCompanyBranches based on branch company name
    var index = masterCompanyBranches.findIndex(p => p.companyName === value.value);

    setProfile((prevProfile) => ({
      ...prevProfile,
      "branchCompany": value,
      "name": value.value, //not really needed since this is not displayed in posting company mode but it completes the address
      "address1": index !== -1 ? masterCompanyBranches[index].address1 : "",
      "address2": index !== -1 ? masterCompanyBranches[index].address2 : "",
      "city": index !== -1 ? masterCompanyBranches[index].city : "",
      "state": index !== -1 ? { label: masterCompanyBranches[index].state, value: masterCompanyBranches[index].state } : null,
      "zip": index !== -1 ? masterCompanyBranches[index].zip : "",
    }));
  };

  const handleIsSelected = (checked, id) => {
    setAddresses((prevAddresses) =>
      prevAddresses.map((addr) =>
        addr.id === id ? { ...addr, isSelected: checked } : addr
      )
    );    
  };
  const handleNewAddress = (address) => {
    insertPreviouslyUsedAddress(address);
    setAddresses((prevAddresses) => [...prevAddresses, address]);
  };

  const filterBranchStates = (masterCompany) => {
    console.log("filterBranchStates=" + masterCompany);
    let l = [];
    if (masterCompany && masterCompany.value !== 'All') {
      //get list of unique branch states for this master company
      for (let i = 0; i < masterCompanyStates.length; i++) {
        if (masterCompanyStates[i].masterCompanyName === masterCompany) {
          l.push({ label: masterCompanyStates[i].state, value: masterCompanyStates[i].state });
        }
      }
    } else {
      //get list of unique branch states
      const result = Object.groupBy(masterCompanyStates, ({ state }) => state);
      const unique = (Object.keys(result));
      for (let i = 0; i < unique.length; i++) {
        l.push({ label: unique[i], value: unique[i] });
      }
    }
    setBranchStates(l);
  };
  const filterBranchCompanies = (masterCompany, masterCompanyState) => {
    //build a list of all master companies that match the company and state provided, empty is a wildcard
    console.log("filterBranchCompanies=" + masterCompany + ", " + masterCompanyState);
    let l = [];
    for (let i = 0; i < masterCompanyBranches.length; i++) {
      let condition1 = (!masterCompany || masterCompany === '' || masterCompany === 'All') || masterCompanyBranches[i].masterCompanyName === masterCompany;
      let condition2 = (!masterCompanyState || masterCompanyState === '' || masterCompanyState === 'All') || masterCompanyBranches[i].state === masterCompanyState;
      if (condition1 && condition2) {
        l.push(
          {
            label: masterCompanyBranches[i].companyName,
            value: masterCompanyBranches[i].companyName
          }
        );
      }
    }
    setBranchCompanies(l);
  };
  const clearProfile = () => {
    setProfile((prevProfile) => ({
      ...prevProfile,
      masterCompany: null,
      branchState: null,
      branchCompany: null,
      id: 0,
      name: "",
      address1: "",
      address2: "",
      city: "",
      state: null,
      zip: "",
      isSelected: false,
    }));
    setValidated(false);

  };
  const cancel = () => {
    closeModal(false);
  };
  const closeAddressModal = async () => {
    await updatePreviouslyUsedAddresses(false, addresses)
    closeModal(true);
  };

  const openAddressEditPanel = (e, mode) => {
    if (!addressOpen) {
      //open address panel
      setAddressOpen(true);
      if (listOpen) {
        setActiveKey(["0", "1"])
      } else {
        setActiveKey(["0"])
      }
    }
    setAddressSource(mode);
  };
  const closeAddressEditPanel = () => {
    if (addressOpen) {
      //close address
      setAddressOpen(false);
      if (listOpen) {
        setActiveKey(["1"])
      } else {
        setActiveKey([])
      }
      clearProfile();
    }
  };
  const collapseAll = () => {
    //this now only collapses address part, list always stays open
    setActiveKey(["1"])
    setAddressOpen(false);
    setListOpen(true);
  };
  const unselectAll = (e) => {
    if (e) { e.preventDefault(); e.stopPropagation(); }

    var l = [];

    for (var i = 0; i < addresses.length; i++) {
      if (addresses[i].isSelected === true) {
        addresses[i].isSelected = false;
        l.push(addresses[i]);
      }else{
        l.push(addresses[i]);
      }
    }
    if (l.length > 0) {
      setAddresses(l);
    }
  };
  const selectAll = (e) => {
    if (e) { e.preventDefault(); e.stopPropagation(); }

    var l = [];

    for (var i = 0; i < addresses.length; i++) {
      if (addresses[i].isSelected === false) {
        addresses[i].isSelected = true;
        l.push(addresses[i]);
      }
    }
    console.log("l",l)
    if (l.length > 0) {
      setAddresses(l);
    }
  };

  const saveAddress = async () => {
    if (profile.id > 0) {
      //update
      await updateAddressPreference(profile, true);
    } else {
      //insert
      await insertPreviouslyUsedAddress(profile);
    }
  };

  const handleSubmit = async (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();
    if (form.checkValidity() &&
      (profile.state && profile.state.label !== "")
    ) {
      await saveAddress();
    } else {
      setValidated(true);
    }
  };

  const editAddress = (e, address) => {
    //move into edit profile and open edit accordian
    setProfile((prevProfile) => ({
      ...prevProfile,
      id: address.id,
      name: address.name,
      address1: address.address1,
      address2: address.address2,
      city: address.city,
      //state: (address.state && address.state.value) ? address.state : null,
      state: (allStates.find(x => x.value === address.state)),
      zip: address.zip,
      isSelected: address.isSelected,
    }));
    openAddressEditPanel(null, 0);
  };

  const updatePreviouslyUsedAddresses = async (fromSave, addressList) => {
    try {

      //if fromSave = false then the call is from a selected operation (select all, unsllect all, of individual select/unselect)
      //if this case honor the isSelected flag on the record, otherwise it is form a Save/Edit - in this case always set as selected
      //also selected options are not verbose

      console.log(addressList);

      var payload = [];

      for (var i = 0; i < addressList.length; i++) {
        var o = {
          id: addressList[i].id,
          name: addressList[i].name,
          address1: addressList[i].address1,
          address2: addressList[i].address2,
          city: addressList[i].city,
          state: addressList[i].state ? (addressList[i].state.value ? addressList[i].state.value : addressList[i].state) : "",
          zip: addressList[i].zip,
          isSelected: fromSave ? true : addressList[i].isSelected,
        }
        payload.push(o);
      }
      const response = await fetch(`${shippingAddressEndpoint}?customerUid=${companyInfo.CustomerUID}`, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${storedToken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload)
      });
      if (response.ok) {
        const success = await response.json();
        console.log(success);
        if (success === true) {
          //clearProfile();
          closeAddressEditPanel();
          if (fromSave) showSuccessMsg('Shipping Address(es) Updated');
        } else {
          showFailedMsg('Failed to Update Shipping Address(es)');
        }
        await loadPreviouslyUsedAddress();
      } else {
        showFailedMsg('Failed to Update Shipping Address(es)');
      }
    } catch (error) {
      showFailedMsg('Failed to Update Shipping Address(es)');
    }
  }

  const updateAddressPreference = async (address, choice) => {
    console.log("address: ",address.id)
    try {
      const newAddress = {
        id: address.id,
        name: address.name,
        address1: address.address1,
        address2: address.address2,
        city: address.city,
        state: address.state?.value || address.state || "",
        zip: address.zip,
        isSelected: choice,
      };
      console.log(choice)
      setAddressSelectPayload((prevAddresses) => {
        if (choice) {
          // Add the address if it doesn't already exist
          if (!prevAddresses.some((prevAddress) => prevAddress.id === newAddress.id)) {
            console.log("// Add new address");
            return [...prevAddresses, newAddress];
          }
        } else {
          // Remove the address if it exists
          console.log("// Remove existing address");
          return prevAddresses.filter((prevAddress) => prevAddress.id !== newAddress.id);
        }
        return prevAddresses; // Return the unchanged list if no action is needed
      });
    } catch (error) {
      showFailedMsg('Failed to Update Shipping Address');
    }
    console.log("resulting address list",addressSelectPayload)
  };

  const insertPreviouslyUsedAddress = async (address) => {
    try {
      console.log("inserting address",address)
      const payload = {
        id: address.id,
        name: address.name,
        address1: address.address1,
        address2: address.address2,
        city: address.city,
        state: address.state ? address.state.value : "",
        zip: address.zip,
        isSelected: true,
      }

      console.log(payload);

      const response = await fetch(`${shippingAddressEndpoint}?customerUid=${companyInfo.CustomerUID}`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${storedToken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload)
      });
      if (response.ok) {
        const data = await response.json();
        console.log(data);
        if (data.id !== 0) {
          //clearProfile();
          closeAddressEditPanel();
          handleIsSelected(true, 0);
          showSuccessMsg('Shipping Address Added');
        } else {
          showFailedMsg('Failed to Add Shipping Address');
        }

      } else {
        showFailedMsg('Failed to recieve ok response', response);
      }
    } catch (error) {
      showFailedMsg('Failed to Add Shipping Address', error);
    }
  };

  const deletePreviouslyUsedAddress = async (id) => {
    try {
      const response = await fetch(`${shippingAddressEndpoint}?id=${id}`, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${storedToken}`,
          'Content-Type': 'application/json',
        }
      });
      if (response.ok) {
        const success = await response.json();
        console.log(success);
        //remove this id from addresses
        if (success === true) {
          let l = addresses.filter(el => el.id !== id);
          setAddresses(l);
          showSuccessMsg('Shipping Address Removed');
        } else {
          showFailedMsg('Failed to Removed Shipping Address');
        }
      } else {
        showFailedMsg('Failed to Removed Shipping Address');
      }
    } catch (error) {
      showFailedMsg('Failed to Removed Shipping Address');
    }
  };
  const deleteAddress = (e, address) => {
    deletePreviouslyUsedAddress(address.id);
  };
  const cancelCollapse = (e) => {
    if (e) { e.preventDefault(); e.stopPropagation(); }
  };
  const loadPreviouslyUsedAddress = async () => {
    console.log("id",companyInfo.CustomerUID)
    try {
      const response = await fetch(`${shippingAddressEndpoint}?customerUid=${companyInfo.CustomerUID}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${storedToken}`,
          'Content-Type': 'application/json',
        }
      });
      if (response.ok) {
        const data = await response.json();
        console.log("SET DATA",data);
        setAddresses(data.map((address) => ({ ...address, isSelected: address.isNew ? true : false })));
      } else {
        showFailedMsg('Failed to fetch previously used address');
      }
    } catch (error) {
      showFailedMsg('Failed to fetch previously used address');
    }
  };
  const Checkbox = ({ label, value, onChange }) => {
    return (
      <label>
        <input type="checkbox" checked={value} onChange={onChange} />
        {label}
      </label>
    );
  };

  const loadPostingCompanies = async () => {
    try {
      const response = await fetch(postingCompanyEndpoint, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${storedToken}`,
          'Content-Type': 'application/json',
        }
      });
      if (response.ok) {
        const data = await response.json();
        console.log("posting response:",data)
        setMasterCompanies(data.MasterCompanies);
        setMasterCompanyStates(data.MasterCompanyStates);
        setMasterCompanyBranches(data.MasterCompanyBranches)
      } else {
        console.error('Failed to fetch PostingCompanies');
      }
    } catch (error) {
      console.error('Failed to fetch PostingCompanies');
    }
  };

  //initializations on show modal
  useEffect(() => {
    if (showModal === true && storedToken) {
      clearProfile();
      loadPostingCompanies();
      console.log("loads modal")
      loadPreviouslyUsedAddress();
    } else {
      clearProfile();
      collapseAll();
      setValidated(false);
    }
  }, [showModal]);

  //initial branch state filter
  useEffect(() => {
    filterBranchStates(); //initial filtering (all)
  }, [masterCompanyStates]);

  //initial branch company filter
  useEffect(() => {
    filterBranchCompanies(); //initial filtering (all)
  }, [masterCompanyBranches]);

  useEffect(() => {
    console.log("profile changed");
  }, [profile]);

  return (
    <>
      <Modal show={showModal} onHide={closeModal} dialogClassName="activity-filter-modal" backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>
            Select Address(es) to Quote Tax (Optional)
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Accordion defaultActiveKey={[]} activeKey={activeKey}>
            <Accordion.Item eventKey="1">
              <Accordion.Header>Select from Customer's Previously Used Address List
                <Button className='address-select-btn btn btn-primary' onClick={(e) => unselectAll(e)}>
                  Unselect All
                </Button>
                <Button className='address-select-btn btn btn-primary' onClick={(e) => selectAll(e)}>
                  Select All
                </Button>
              </Accordion.Header>
              <Accordion.Body>
                <Row className='mb-0'>
                  <Form.Group as={Col} md="12" controlId="association">
                    <div className="address-box">
                      {addresses && addresses.length > 0 ?
                        <ul>
                          {addresses.map((address, index) =>
                            <li key={address.id} className="address-item">
                              <div className="address-item-grid" onClick={cancelCollapse}>
                                <div className="address-item-c">
                                  <Checkbox
                                    value={address.isSelected}
                                    onChange={(e) => handleIsSelected(e.target.checked, address.id)}
                                  />
                                </div>
                                <div className="address-item-a1">{address.name}</div>
                                <div className="address-item-a2">{address.address1}</div>
                                <div className="address-item-a3">{address.address2}</div>
                                <div className="address-item-a4">{address.city + ' ' + address.state + ' ' + address.zip}</div>
                                <div className="address-item-b">
                                  <Dropdown as={ButtonGroup}>
                                    <Dropdown.Toggle variant='top-form-new'>
                                      <div className='user-button'>
                                        <div className='hidden-sm-down'>Action</div>
                                        <i className="fa fa-fw fa-caret-down caret-center user-button-caret" aria-hidden="true"></i>
                                      </div>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                      <Dropdown.Item onClick={(e) => editAddress(e, address)}>Edit Customer's Address</Dropdown.Item>
                                      <Dropdown.Item onClick={(e) => deleteAddress(e, address)}>Delete from Customer's Address List</Dropdown.Item>
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </div>
                                <div className="address-item-l"><hr /></div>
                              </div>
                            </li>
                          )}
                        </ul>
                        : <span>No shipping addresses have been added.</span>}
                    </div>
                  </Form.Group>
                </Row>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                <div className="baq-accordian-title">
                  Not seeing an address in the Customers's List above?
                </div>
                <Dropdown as={ButtonGroup}>
                  <Dropdown.Toggle variant='top-form-new'>
                    <div className='user-button' >
                      <div className='hidden-sm-down'>Add Address</div>
                      <i className="fa fa-fw fa-caret-down caret-center user-button-caret" aria-hidden="true"></i>
                    </div>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item onClick={(e) => openAddressEditPanel(e, 2)}>Select OOH Posting Company Address</Dropdown.Item>
                    <Dropdown.Item onClick={(e) => openAddressEditPanel(e, 0)}>Enter New Address</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </Accordion.Header>

              <Accordion.Body>
                <Form noValidate validated={validated}>
                  {addressSource === 2 ?
                    <>
                      <Row className='mb-2'>
                        <Form.Group as={Col} md="6" controlId="BranchCompany">
                          <FloatingLabel controlId="BranchCompany" label="Branch Company" className="w-100 floating-select">
                            <Select
                              name="state"
                              className={"companyform-dropdown"}
                              classNamePrefix="select"
                              isClearable={true}
                              isSearchable={true}
                              options={masterCompanies}
                              value={profile.masterCompany}
                              onChange={handleMasterCompanyChange}
                              filterOption={createFilter({ ignoreAccents: false })} //this for performance
                              components={{ Option: CustomOption }} //this for performance
                            />
                          </FloatingLabel>
                        </Form.Group>
                        <Form.Group as={Col} md="6" controlId="BranchState">
                          <FloatingLabel controlId="BranchState" label="Branch State" className="w-100 floating-select">
                            <Select
                              name="state"
                              className={"companyform-dropdown"}
                              classNamePrefix="select"
                              isClearable={true}
                              isSearchable={true}
                              options={branchStates}
                              value={profile.branchState}
                              onChange={handleBranchStateChange}
                              filterOption={createFilter({ ignoreAccents: false })} //this for performance
                              components={{ Option: CustomOption }} //this for performance
                            />
                          </FloatingLabel>
                        </Form.Group>
                      </Row>
                      <Row className='mb-2'>
                        <Form.Group as={Col} md="12" controlId="BranchName">
                          <FloatingLabel controlId="BranchName" label="Company" className="w-100 floating-select">
                            <Select
                              name="branchName"
                              className={"companyform-dropdown"}
                              classNamePrefix="select"
                              isClearable={true}
                              isSearchable={true}
                              options={branchCompanies}
                              value={profile.branchCompany}
                              onChange={handleBranchCompanyChange}
                              filterOption={createFilter({ ignoreAccents: false })} //this for performance
                              components={{ Option: CustomOption }} //this for performance
                            />
                          </FloatingLabel>
                        </Form.Group>
                      </Row>
                    </>
                    :
                    <Row className='mb-2'>
                      <Form.Group as={Col} md="12" controlId="name">
                        <FloatingLabel controlId="name" label="Name" className="w-100 required">
                          <Form.Control value={profile.name} name='name' required type="text" placeholder="Company" onChange={handleProfileChange} />
                          <Form.Control.Feedback type="invalid">{'Name is required.'}</Form.Control.Feedback>
                        </FloatingLabel>
                      </Form.Group>
                    </Row>
                  }
                  <Row className='mb-2'>
                    <Form.Group as={Col} md="12" controlId="address1">
                      <FloatingLabel controlId="address1" label="Address 1" className="w-100 required">
                        <Form.Control value={profile.address1} name='address1' required type="text" placeholder="Address 1" onChange={handleProfileChange} disabled={addressSource === 2} />
                        <Form.Control.Feedback type="invalid">{'Address 1 is required.'}</Form.Control.Feedback>
                      </FloatingLabel>
                    </Form.Group>
                  </Row>
                  <Row className='mb-2'>
                    <Form.Group as={Col} md="12" controlId="address2">
                      <FloatingLabel controlId="address2" label="Address 2" className="w-100">
                        <Form.Control value={profile.address2} name='address2' type="text" placeholder="Address 2" onChange={handleProfileChange} disabled={addressSource === 2} />
                      </FloatingLabel>
                    </Form.Group>
                  </Row>
                  <Row className='mb-3'>
                    <Form.Group as={Col} md="4" controlId="city">
                      <FloatingLabel controlId="city" label="City" className="w-100 required">
                        <Form.Control value={profile.city} name='city' required type="text" placeholder="City" onChange={handleProfileChange} disabled={addressSource === 2} />
                        <Form.Control.Feedback type="invalid">{'City is required.'}</Form.Control.Feedback>
                      </FloatingLabel>
                    </Form.Group>
                    <Form.Group as={Col} md="4" controlId="state">
                      <FloatingLabel controlId="state" label="State" className={profile && profile.state !== null ? "w-100 floating-select" : "w-100 floating-select required"}>
                        <Select
                          name="state"
                          className={validated ? (profile.state && profile.state.value !== "" ? "companyform-dropdown valid" : "companyform-dropdown invalid") : "companyform-dropdown"}
                          classNamePrefix="select"
                          isClearable={true}
                          isSearchable={true}
                          options={allStates}
                          value={profile.state}
                          onChange={handleStateChange}
                          isDisabled={addressSource === 2}
                          filterOption={createFilter({ ignoreAccents: false })} //this for performance
                          components={{ Option: CustomOption }} //this for performance
                        />
                        {(validated && !(profile.state && profile.state.value !== "")) ?
                          <div className="custom-error-label">State is required.</div>
                          : null}
                      </FloatingLabel>
                    </Form.Group>
                    <Form.Group as={Col} md="4" controlId="Zip">
                      <FloatingLabel controlId="Zip" label="Zip" className="w-100 required">
                        <Form.Control value={profile.zip} name='zip' required type="text" placeholder="Zip" onChange={handleProfileChange} disabled={addressSource === 2} />
                        <Form.Control.Feedback type="invalid">{'Zip is required.'}</Form.Control.Feedback>
                      </FloatingLabel>
                    </Form.Group>
                  </Row>
                  <Row className='mb-0'>
                    <Form.Group as={Col} md="12" controlId="SaveAddress">
                      <Button onClick={(e) => closeAddressEditPanel()}>
                        Close
                      </Button>
                      <Button className='pull-right' variant="primary" onClick={()=>handleNewAddress(profile)}>
                        Update Customer's Address List & Select for Quote
                      </Button>
                    </Form.Group>
                  </Row>
                </Form>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Modal.Body>
        <Modal.Footer>
          <Button className='btn btn-outline-success btn-easy-button' onClick={closeAddressModal}>
            Excel
          </Button>
          <Button variant="secondary" onClick={cancel}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );


}
